module.exports = __webpack_public_path__ + "static/media/B.67b91d63.png";